/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Sponsor_DescInputs */

const en_landing_pricing_sponsor_desc = /** @type {(inputs: Landing_Pricing_Sponsor_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximum exposure`)
};

const zh_landing_pricing_sponsor_desc = /** @type {(inputs: Landing_Pricing_Sponsor_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最大曝光`)
};

/**
* | output |
* | --- |
* | "Maximum exposure" |
*
* @param {Landing_Pricing_Sponsor_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_sponsor_desc = /** @type {((inputs?: Landing_Pricing_Sponsor_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Sponsor_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_sponsor_desc(inputs)
	return zh_landing_pricing_sponsor_desc(inputs)
});
export { landing_pricing_sponsor_desc as "landing.pricing.sponsor_desc" }